import { Link } from "react-router-dom";
import { CheckCircle2, Phone, Mail } from "lucide-react";
import Reveal from "../components/Reveal";
import SEO from "../components/SEO";
import { SITE } from "../data/content";

export default function ThankYou() {
  return (
    <main className="pt-28 pb-20 min-h-[80vh] flex items-center" data-testid="thank-you-page">
      <SEO
        title="Thank You | Yellow Video Production"
        description="Thanks for getting in touch with Yellow Video Production. We'll send a fixed-price quote within 4 working hours."
        path="/thank-you"
        noIndex
      />

      <section className="yv-container">
        <Reveal>
          <div className="max-w-2xl mx-auto text-center">
            <div className="inline-flex items-center justify-center w-20 h-20 rounded-full bg-[var(--yellow)]/15 border border-[var(--yellow)]/30 mb-8">
              <CheckCircle2 className="text-[var(--yellow)]" size={44} />
            </div>

            <p className="yv-eyebrow">Quote enquiry received</p>
            <h1 className="yv-h1 mt-3">
              Thanks, we're on it.
            </h1>
            <p className="text-white/70 text-lg leading-relaxed mt-6">
              One of the Yellow team will be in touch within <strong className="text-white">4 working hours</strong> with a fixed price and details of our production process.
            </p>

            <div className="grid sm:grid-cols-2 gap-4 mt-12">
              <a href={`tel:${SITE.phone.replace(/\s/g, "")}`} className="flex items-center gap-3 px-5 py-4 rounded-md bg-white/[0.04] border border-white/10 hover:border-[var(--yellow)] transition group" data-testid="thank-you-call">
                <Phone className="text-[var(--yellow)] flex-shrink-0" size={20} />
                <div className="text-left">
                  <p className="text-white/50 text-xs">In a hurry? Call us</p>
                  <p className="text-white font-bold">{SITE.phone}</p>
                </div>
              </a>
              <a href={`mailto:${SITE.email}`} className="flex items-center gap-3 px-5 py-4 rounded-md bg-white/[0.04] border border-white/10 hover:border-[var(--yellow)] transition group" data-testid="thank-you-email">
                <Mail className="text-[var(--yellow)] flex-shrink-0" size={20} />
                <div className="text-left">
                  <p className="text-white/50 text-xs">Or drop a line</p>
                  <p className="text-white font-bold text-sm">{SITE.email}</p>
                </div>
              </a>
            </div>

            <div className="mt-12 pt-8 border-t border-white/10">
              <p className="text-white/50 text-sm mb-4">While you wait, take a look at some recent work:</p>
              <div className="flex flex-wrap gap-3 justify-center">
                <Link to="/showreel" className="yv-btn yv-btn-primary" data-testid="thank-you-showreel">Watch the showreel</Link>
                <Link to="/" className="yv-btn yv-btn-secondary" data-testid="thank-you-home">Back to home</Link>
              </div>
            </div>
          </div>
        </Reveal>
      </section>
    </main>
  );
}
